import Disclaimer from "../Fusion/Component/Disclaimer/Disclaimer";

window.disclaimer = window.disclaimer || new Disclaimer();
